export const DEFAULT_UPDATE_TIMES = ["08:00", "13:00"];
export const UPDATE_CHECK_DELAY_MINUTES = 5;

export function nextRefreshAt(updateTimes, now = new Date()) {
  const times = Array.isArray(updateTimes) && updateTimes.length ? updateTimes : DEFAULT_UPDATE_TIMES;
  const candidates = [];

  for (const dayOffset of [0, 1]) {
    for (const value of times) {
      const [hours, minutes] = value.split(":").map(Number);
      const candidate = new Date(now);
      candidate.setDate(candidate.getDate() + dayOffset);
      candidate.setHours(hours, minutes + UPDATE_CHECK_DELAY_MINUTES, 0, 0);
      if (candidate > now) candidates.push(candidate);
    }
  }

  return new Date(Math.min(...candidates.map((candidate) => candidate.getTime())));
}
